import Icon from '@components/v2/ui/Icon/Icon';
import { Box } from '@mui/material';
import { Ellipsis } from 'lucide-react';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';
import { useSeeAllConnections } from '../hooks/useSeeAllConnections';
import { StoreConnectionsTestIds } from '../storeConnections.testIds';
import { BRAND_TILE_AVATAR_SIZE } from '../storeConnections.utils';
import BrandTile from './BrandTile';

const SeeMoreCard = () => {
  const { translate } = useTranslation();
  const { goToConnections } = useSeeAllConnections();

  return (
    <BrandTile
      label={translate(LangEnum.HOMEPAGE_SECTIONS_SEE_MORE)}
      testId={StoreConnectionsTestIds.SEE_MORE}
      onClick={goToConnections}
    >
      <Box
        sx={{
          width: BRAND_TILE_AVATAR_SIZE,
          height: BRAND_TILE_AVATAR_SIZE,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'text.secondary',
        }}
      >
        <Icon icon={Ellipsis} size="lg" />
      </Box>
    </BrandTile>
  );
};

export default SeeMoreCard;
